import { render } from "./PasswordForgotForm.vue?vue&type=template&id=c8894410&ts=true"
import script from "./PasswordForgotForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForgotForm.vue?vue&type=script&lang=ts"

import "./PasswordForgotForm.vue?vue&type=style&index=0&id=c8894410&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__